module.exports = __webpack_public_path__ + "static/img/homepage-house.037a224.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homepage-house.jpg
// module id = NRYW
// module chunks = 0